import * as launchDarklyService from "integrations/launch-darkly";
import { put, takeEvery, call } from "redux-saga/effects";

import { USER_LOGIN } from "../auth/actions";
import {
  FEATURE_FLAGS_FETCH_SUCCESS,
  FEATURE_FLAGS_FETCH_FAILURE,
} from "./actions";

function* getFeatureFlagsSaga() {
  try {
    const flags = yield launchDarklyService.initializeLaunchDarkly();
    yield put({ type: FEATURE_FLAGS_FETCH_SUCCESS, payload: flags });
    yield takeEvery(USER_LOGIN, setLaunchDarklyUser);
  } catch (error) {
    yield put({ type: FEATURE_FLAGS_FETCH_FAILURE, error });
  }
}

function* setLaunchDarklyUser(action) {
  const flags = yield call(
    launchDarklyService.identifyUser,
    action.payload.user,
  );
  yield put({ type: FEATURE_FLAGS_FETCH_SUCCESS, payload: flags });
}

const featureFlagsSagas = [getFeatureFlagsSaga()];

export { featureFlagsSagas };
